import { Chip, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";
import { LimitedProjectUserResource } from "@iventis/domain-model/model/limitedProjectUserResource";
import { LimitedProjectResource } from "@iventis/domain-model/model/limitedProjectResource";
import { Theme } from "@emotion/react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";

interface LimitChipRemainingProps {
    currentUsage: number;
    maxUsage: number;
    resource: LimitedProjectResource | LimitedProjectUserResource;
}

/**
 * Display a chip showing currentUsage of maxUsage for Resource. Will not render if maxUsage is null
 */
export const LimitChipRemaining: FunctionComponent<LimitChipRemainingProps> = ({ currentUsage, maxUsage, resource }) => {
    const theme = useTheme<Theme>();
    const translate = useIventisTranslate();

    return maxUsage == null ? (
        <></>
    ) : (
        <Chip
            label={translate(Content.subscriptionplan3.limits.out_of, {
                current: currentUsage,
                maximum: maxUsage,
                resources: translate(Content.subscriptionplan3.limits.limitedResource[resource]),
            })}
            style={{ backgroundColor: currentUsage >= maxUsage ? theme.secondaryColors.error : theme.tertiaryColors.primary, color: theme.typographyColors.blank }}
        />
    );
};
